import React, { useState } from "react";
import {COMMON_TRANSLATIONS, ROUTES} from "../utils/constants";

import IconCloseWhite from "../assets/icon-close-white.svg";
import IconHamburger from "../assets/icon-hamburger.svg";
import LogoMobile from "../assets/logo-mobile.svg";
import GtfsLogo from "../assets/logo-desktop.svg";

import IconCloseWhiteDark from "../assets/icon-close-white-dark.svg";
import IconHamburgerDark from "../assets/icon-hamburger-dark.svg";
import LogoMobileDark from "../assets/logo-mobile-dark.svg";
import GtfsLogoDark from "../assets/logo-desktop-dark.svg";

import DownloadButton from "../components/download-button";
import DownloadForm from "../components/download-form";
import AccessibilityHeader from "../components/accessibility-header";


const Header = ({ onThemeChange }) => {
  const selectedLang = typeof window !== "undefined" ? window.localStorage.getItem("lang") || "en" : "en";
  const url = new URL(window.location);
  const { pathname } = url;
  const [showNav, setShowNav] = useState(false);
  const [showDownload, setShowDownload] = useState(false);

  const clearPathName = pathname.replaceAll("/", "");

  return (
    <>
      {
        showDownload && (
          <DownloadForm onCloseClick={() => setShowDownload(false)} />
        )
      }
      <header id="header">
        <AccessibilityHeader onThemeChange={onThemeChange} />
        <div id="header-content">
          <a href={ROUTES.root} id="header-logo-link">
            <picture className="light">
              <source srcSet={LogoMobile} media="(max-width: 1044px)"/>
              <img src={GtfsLogo} alt="Logo" id="header-logo"/>
            </picture>
            <picture className="dark">
              <source srcSet={LogoMobileDark} media="(max-width: 1044px)"/>
              <img src={GtfsLogoDark} alt="Logo" id="header-logo"/>
            </picture>
          </a>
          <nav id="desktop-nav">
            <a className={`link ${clearPathName === ROUTES.static.replaceAll("/", "") ? 'active' : ''}`}
                  href={ROUTES.static}>
              {COMMON_TRANSLATIONS[selectedLang].static}
            </a>
            <a className={`link ${clearPathName === ROUTES.realtime.replaceAll("/", "") ? 'active' : ''}`}
                  href={ROUTES.realtime}>{COMMON_TRANSLATIONS[selectedLang].realtime}</a>
            <a className={`link ${clearPathName === ROUTES.gtfs.replaceAll("/", "") ? 'active' : ''}`}
                  href={ROUTES.gtfs}>
              {COMMON_TRANSLATIONS[selectedLang].gtfs}
            </a>
            <a className={`link ${clearPathName === ROUTES.about.replaceAll("/", "") ? 'active' : ''}`}
                  href={ROUTES.about}>
              {COMMON_TRANSLATIONS[selectedLang].about}
            </a>
            <DownloadButton/>
          </nav>
          <button id="mobile-hamburger" onClick={() => setShowNav(true)}>
            <img src={IconHamburgerDark} className="dark"/>
            <img src={IconHamburger} className="light"/>
          </button>
        </div>
        {
          showNav && (
            <nav id="mobile-nav">
              <div id="mobile-nav-header">
                <span>Menu</span>
                <button id="mobile-nav-close" onClick={() => setShowNav(false)}>
                  <img src={IconCloseWhite} className="light"/>
                  <img src={IconCloseWhiteDark} className="dark"/>
                </button>
              </div>
              <div id="mobile-nav-links">
              <a className={`link ${pathname === ROUTES.root ? 'active' : ''}`} href={ROUTES.root}>
                {COMMON_TRANSLATIONS[selectedLang].home}
                </a>
                <a className={`link ${pathname === ROUTES.static ? 'active' : ''}`} href={ROUTES.static}>
                  {COMMON_TRANSLATIONS[selectedLang].static}
                </a>
                <a className={`link ${pathname === ROUTES.realtime ? 'active' : ''}`} href={ROUTES.realtime}>
                  {COMMON_TRANSLATIONS[selectedLang].realtime}
                </a>
                <a className={`link ${pathname === ROUTES.gtfs ? 'active' : ''}`} href={ROUTES.gtfs}>
                  {COMMON_TRANSLATIONS[selectedLang].gtfs}
                </a>
                <a className={`link ${pathname === ROUTES.about ? 'active' : ''}`} href={ROUTES.about}>
                  {COMMON_TRANSLATIONS[selectedLang].about}
                </a>
              </div>
              <AccessibilityHeader />
            </nav>
          )
        }
      </header>
    </>
  );
};

export default Header;
